import type { DailyCall } from '@daily-co/daily-js'
import { createContext } from 'react'

export interface VisioContextType {
  shouldStartCall: boolean
  kioskId: number | null
  storeId: number | null
  includeVideo: boolean
  openingEventId: number | null
  isCallInProgress: boolean
  callObject: DailyCall | null
  callLabel: string | null
  setCallObject: (callObject: DailyCall | null) => void
  clearCallObject: () => void
  askCall: (
    kioskId: number,
    storeId: number,
    includeVideo: boolean,
    openingEventId?: number,
    callLabel?: string,
  ) => void
  startCall: () => void
  endCall: () => void
}

export const VisioContext = createContext<VisioContextType>({
  askCall: () => {},
  callObject: null,
  callLabel: null,
  clearCallObject: () => {},
  endCall: () => {},
  includeVideo: false,
  openingEventId: null,
  isCallInProgress: false,
  kioskId: null,

  setCallObject: () => {},

  shouldStartCall: false,

  startCall: () => {},

  storeId: null,
})
